var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"50px"}},[_c('h3',[_vm._v("Ligações Recebidas na Semana")]),_vm._v(" "),_c('apexchart',{ref:"mixedChart",attrs:{"type":"line","options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }